const NAMES = ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"] as const;

const WHITE = [0, 2, 4, 5, 7, 9, 11];

const LOWER_WHITE = ["KeyZ", "KeyX", "KeyC", "KeyV", "KeyB", "KeyN", "KeyM"];
const UPPER_WHITE = ["KeyQ", "KeyW", "KeyE", "KeyR", "KeyT", "KeyY", "KeyU"];
const LOWER_BLACK: Record<number, string> = {
  1: "KeyS",
  3: "KeyD",
  6: "KeyG",
  8: "KeyH",
  10: "KeyJ",
};
const UPPER_BLACK: Record<number, string> = {
  1: "Digit2",
  3: "Digit3",
  6: "Digit5",
  8: "Digit6",
  10: "Digit7",
};

const LABELS: Record<string, string> = {
  KeyZ: "Z",
  KeyX: "X",
  KeyC: "C",
  KeyV: "V",
  KeyB: "B",
  KeyN: "N",
  KeyM: "M",
  KeyS: "S",
  KeyD: "D",
  KeyG: "G",
  KeyH: "H",
  KeyJ: "J",
  KeyQ: "Q",
  KeyW: "W",
  KeyE: "E",
  KeyR: "R",
  KeyT: "T",
  KeyY: "Y",
  KeyU: "U",
  Digit2: "2",
  Digit3: "3",
  Digit5: "5",
  Digit6: "6",
  Digit7: "7",
};

export const OCTAVE_BASES = [36, 48, 60] as const;

export function isWhite(midi: number) {
  return WHITE.includes(midi % 12);
}

export function noteName(midi: number) {
  return `${NAMES[midi % 12]}${Math.floor(midi / 12) - 1}`;
}

export function midiToFreq(midi: number) {
  return 440 * 2 ** ((midi - 69) / 12);
}

export function codeForMidi(midi: number, base: number) {
  const rel = midi - base;
  if (rel < 0 || rel >= 24) return null;
  const pc = rel % 12;
  const oct = rel < 12 ? 0 : 1;
  const whiteIndex = WHITE.indexOf(pc);
  if (whiteIndex >= 0) return (oct === 0 ? LOWER_WHITE : UPPER_WHITE)[whiteIndex] ?? null;
  return (oct === 0 ? LOWER_BLACK : UPPER_BLACK)[pc] ?? null;
}

export function keyLabel(code: string | null) {
  if (!code) return "";
  return LABELS[code] ?? "";
}

export function midiForCode(code: string, base: number) {
  for (let midi = base; midi < base + 24; midi++) {
    if (codeForMidi(midi, base) === code) return midi;
  }
  return null;
}

export function whitesBefore(midi: number, base: number) {
  let count = 0;
  for (let m = base; m < midi; m++) if (isWhite(m)) count += 1;
  return count;
}
